<template>
  <div>
    <form class="form-horizontal mt-3">
      <div class="row">
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-6">
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.nameKh'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    ref="mother_name_kh"
                    v-model.trim="model.mother_name_kh"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_name_kh') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_name_kh')"
                  >
                    {{ errors.first('mother_name_kh') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label required">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.nameEn'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.mother_name_en"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid':
                        errors.has('mother_name_en') ||
                        $v.model.mother_name_en.$error,
                    }"
                    @input="$event => onMotherNameInput(model.mother_name_en)"
                  />
                  <span
                    class="invalid-feedback"
                    v-if="motherNameEnErrors.length > 0"
                    >{{ motherNameEnErrors[0] }}</span
                  >
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_name_en')"
                  >
                    {{ errors.first('mother_name_en') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.parentProfile.nationality'
                    )
                  }}
                  <i class="fas fa-spinner spin" v-if="nationality_fetch"></i>
                </label>
                <div class="col-md-8">
                  <ts-search-select
                    v-model.number="model.mother_nationality_id"
                    :options="
                      nationalities.map((el) => ({
                        value: el.id,
                        text: el.nationality,
                      }))
                    "
                    :class="{
                      'is-invalid': errors.has('mother_nationality_id'),
                    }"
                  ></ts-search-select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_nationality_id')"
                  >
                    {{ errors.first('mother_nationality_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t('school.academic.operation.profile_mgt.parentProfile.dob')
                }}</label>
                <div class="col-md-8">
                  <ts-date-picker-input
                    v-model="model.mother_dob"
                    :class="{ 'is-invalid': errors.has('mother_dob') }"
                  ></ts-date-picker-input>
                  <div class="invalid-feedback" v-if="errors.has('mother_dob')">
                    {{ errors.first('mother_dob') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.religion'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model="model.mother_religion"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_religion') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_religion')"
                  >
                    {{ errors.first('mother_religion') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.occupation'
                  )
                }}</label>
                <div class="col-md-8">
                  <ts-search-select
                    v-model.number="model.mother_occupation_id"
                    :options="
                      occupations.map((el) => ({
                        value: el.occupation_id,
                        text: el.occupation_name_en,
                      }))
                    "
                    :class="{
                      'is-invalid': errors.has('mother_occupation_id'),
                    }"
                  ></ts-search-select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_occupation_id')"
                  >
                    {{ errors.first('mother_occupation_id') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.phoneLineOne'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.mother_phone1"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_phone1') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_phone1')"
                  >
                    {{ errors.first('mother_phone1') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.phoneLineSecond'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.mother_phone2"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_phone2') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_phone2')"
                  >
                    {{ errors.first('mother_phone2') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.email'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model="model.mother_emails"
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_emails') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_emails')"
                  >
                    {{ errors.first('mother_emails') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.facebook'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.mother_facebook"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_facebook') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_facebook')"
                  >
                    {{ errors.first('mother_facebook') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.linkedIn'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.mother_linked_in"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_linked_in') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_linked_in')"
                  >
                    {{ errors.first('mother_linked_in') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.telegram'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.mother_telegram"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_telegram') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_telegram')"
                  >
                    {{ errors.first('mother_telegram') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t('school.academic.operation.profile_mgt.parentProfile.line')
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.mother_line"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_line') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_line')"
                  >
                    {{ errors.first('mother_line') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.weChat'
                  )
                }}</label>
                <div class="col-md-8">
                  <input
                    v-model.trim="model.mother_wechat"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('mother_wechat') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_wechat')"
                  >
                    {{ errors.first('mother_wechat') }}
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label">{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.notification'
                  )
                }}</label>
                <div class="col-md-8">
                  <div class="ts-inline-block">
                    <ts-checkbox v-model="model.mother_sms">{{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.sms'
                      )
                    }}</ts-checkbox>
                  </div>
                  <div class="ts-inline-block ml-2">
                    <ts-checkbox v-model="model.mother_email">{{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.email'
                      )
                    }}</ts-checkbox>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <label class="col-md-3 col-form-label"></label>
                <div class="col-md-8">
                  <div class="ts-inline-block">
                    <ts-checkbox v-model="model.mother_allow_pickup">{{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.autoCreateCard'
                      )
                    }}</ts-checkbox>
                  </div>
                  <div class="ts-inline-block ml-2"></div>
                </div>
              </div>
              <div class="row form-group pt-2">
                <label class="col-md-3 col-form-label"></label>
                <div class="col-md-8">
                  <ts-checkbox 
                    v-model="model.mother_login"
                    @change="onIsMotherLogin"
                  >{{
                    $t(
                      'school.academic.operation.profile_mgt.parentProfile.autoCreateLoginName'
                    )
                  }}</ts-checkbox>
                </div>
              </div>
              <div class="row form-group pt-3">
                <label class="col-md-3 col-form-label">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.parentProfile.loginName'
                    )
                  }}
                  <span class="validate" v-if="model.mother_login">*</span>
                </label>
                <div class="col-md-8">
                  <input
                    v-model="model.mother_login_name"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid':
                        errors.has('mother_login_name') ||
                        $v.model.mother_login_name.$error,
                    }"
                  />
                  <span
                    class="invalid-feedback"
                    v-if="motherLoginNameErrors.length > 0"
                    >{{ motherLoginNameErrors[0] }}</span
                  >
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('mother_login_name')"
                  >
                    {{ errors.first('mother_login_name') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <ts-image-input
                :file="file"
                @input="(file) => (model.mother_photo = file)"
                :width="175"
                :height="225"
                crop
              ></ts-image-input>
            </div>
          </div>
          <div class="row froup">
            <div class="col-md-12 text-center">
              <ts-button @click="takePicture">
                <i class="fas fa-camera mr-2"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.takePicture'
                  )
                }}
              </ts-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
import WebCam from './web-cam'

export default {
  name: 'motherForm',
  props: ['value', 'validate', 'clear'],
  data() {
    return {
      model: {},
      errors: new Errors(),
      nationality_fetch: true,
      occupation_fetch: true,
      file: require('../../../assets/staff-default-women.png'),
    }
  },
  async created() {
    this.model = this.value
    await this.setEditData()
    this.$refs.mother_name_kh.focus()
  },
  validations: {
    model: {
      mother_name_en: { required },
      mother_login_name: {
        required: requiredIf(function (nestModel) {
          return this.model.mother_login
        }),
      },
    },
    form: ['model.mother_name_en', 'model.mother_login_name'],
  },
  computed: {
    ...mapState('parentProfile', [
      'nationalities',
      'occupations',
      'photoBlob',
      'edit_data',
    ]),
    motherNameEnErrors() {
      const errors = []
      if (!this.$v.model.mother_name_en.$error) return errors
      !this.$v.model.mother_name_en.required && errors.push('Required')
      return errors
    },
    motherLoginNameErrors() {
      const errors = []
      if (!this.$v.model.mother_login_name.$error) return errors
      !this.$v.model.mother_login_name.required && errors.push('Required')
      return errors
    },
  },
  methods: {
    ...mapActions('parentProfile', ['getNationality', 'getOccupation']),
    validateForm() {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      return isValid
    },
    takePicture() {
      this.$modal.show(
        WebCam,
        {},
        {
          height: 'auto',
          width: '40%',
          scrollable: true,
          clickToClose: false,
        },
        {
          'before-close': this.getPhoto,
        }
      )
    },
    getPhoto() {
      this.file = this.photoBlob ? this.readBlob(this.photoBlob) : this.file
      this.model.mother_photo = this.photoBlob
        ? new File([this.photoBlob], 'fatherphoto', { type: 'image/jpeg' })
        : ''
      this.$store.commit('parentProfile/SET_PHOTO_BLOB', '')
    },
    readBlob(blob) {
      return window.URL.createObjectURL(
        new Blob([blob], { type: 'image/jpeg' })
      )
    },
    onMotherNameInput(value) {
      if (value !== '' && this.model.mother_login == true) {
        this.model.mother_login_name = value.split(' ').join('.')
      } else {
        this.model.mother_login_name = ''
      }
    },
    onIsMotherLogin(value) {
      if (value == true && this.model.mother_name_en !== '') {
        this.model.mother_login_name = this.model.mother_name_en
          .split(' ')
          .join('.')
      } else {
        this.model.mother_login_name = ''
      }
    },
    async setEditData() {
      await this.getNationality().finally(() => {
        this.nationality_fetch = false
      })
      await this.getOccupation().finally(() => {
        this.occupation_fetch = false
      })
      if (!_.isEmpty(this.edit_data)) {
        ;(this.model.student_parent_id = this.edit_data.student_parent_id),
          (this.model.mother_name_kh = this.edit_data.mother_name_kh),
          (this.model.mother_name_en = this.edit_data.mother_name_en),
          (this.model.mother_nationality_id =
            this.edit_data.mother_nationality_id),
          (this.model.mother_religion = this.edit_data.mother_religion),
          (this.model.mother_dob = this.edit_data.mother_dob),
          (this.model.mother_occupation_id =
            this.edit_data.mother_occupation_id),
          (this.model.mother_photo = this.edit_data.mother_photo),
          (this.model.mother_phone1 = this.edit_data.mother_phone1),
          (this.model.mother_phone2 = this.edit_data.mother_phone2),
          (this.model.mother_emails = this.edit_data.mother_emails),
          (this.model.mother_facebook = this.edit_data.mother_facebook),
          (this.model.mother_linked_in = this.edit_data.mother_linked_in),
          (this.model.mother_telegram = this.edit_data.mother_telegram),
          (this.model.mother_line = this.edit_data.mother_line),
          (this.model.mother_wechat = this.edit_data.mother_wechat),
          (this.model.mother_sms = this.edit_data.mother_sms),
          (this.model.mother_email = this.edit_data.mother_email),
          (this.model.mother_login = this.edit_data.mother_login),
          (this.model.mother_login_name = this.edit_data.mother_login_name),
          (this.model.mother_allow_pickup = this.edit_data.mother_allow_pickup)
        this.file = this.model.mother_photo
      }
    },
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true,
    },
    clear: function (value) {
      if (value) {
        this.model = this.value
        this.file = ''
        // this.file = require('../../../assets/staff-default-women.png')
      }
    },
  },
}
</script>
<style lang="css" scoped>
.file-input-container {
  width: 174px !important;
  margin: 0 auto;
  border: 1px solid #eaeaea;
  padding: 4px;
  border-radius: 5px;
}
</style>
